import React from "react";
import { Button, Message, Modal } from "semantic-ui-react";
import { ChargeListSmallComponent } from "../charge-list-small";
import { t } from "../../../constant/translations";

export const BulkDeleteCharges = (props) => {
  const handleDelete = () => {
    props.charges.map((ch) => {
      props.deleteCharge(ch);
    });
  };

  const { charges } = props;

  return (
    <Modal
      closeIcon={true}
      trigger={
        <Button size={"tiny"} basic={true} negative={true}>
          {t("charge.delete_selected")} ({charges.length})
        </Button>
      }
    >
      <Modal.Header>
        {t("charge.delete_due")} ({charges.length})
      </Modal.Header>
      <Modal.Content>
        <div>{t("charge.selected_for_deletion")}</div>
        <ChargeListSmallComponent charges={charges} />
        {props.error.exists() && (
          <Message negative={true} content={props.error.getGlobalErrorMsg()} />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          icon="remove"
          onClick={handleDelete}
          content={t("userActions.delete")}
          negative={true}
          loading={props.loading}
        />
      </Modal.Actions>
    </Modal>
  );
};
